import { useState } from "react";
import { GetImages } from "../utils/GetImages";

const CapRateComponent = ({ type, address, percent, img }) => {
  const [showInfoBox, setShowInfoBox] = useState(false);

  const getImageSource = () => {
    return img ? `data:image/jpeg;base64,${img}` : GetImages.DummyPropertyPic;
  };

  return (
    <div className="d-flex align-items-center justify-content-between w-100 capRateComponent pt-3 pb-3">
      <div className="d-flex align-items-center gap-2">
        <img
          className="rounded"
          width={44}
          height={44}
          src={getImageSource()}
        />
        <div className="typeAddressContainer">
          <p className="sub_text grey_subtext1">{type}</p>
          <p className="normal_text ">{address}</p>
        </div>
      </div>
      <div className="d-flex align-items-center gap-1 sub_heading position-relative">
        <p>{percent}</p>
        <div
          style={{ width: 25, height: 25 }}
          onMouseOver={() => setShowInfoBox(true)}
          onMouseLeave={() => setShowInfoBox(false)}
        >
          <img className="clickable" width={16} height={16} src={GetImages.InfoIcon} />
        </div>
        {showInfoBox && (
          <div className="toolTipContainer1">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <p className="sub_text">Property Value</p>
              <p className="normal_text fw-500">$20,000</p>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <p className="sub_text">NOI</p>
              <p className="normal_text fw-500">$5,000</p>
            </div>
            <div className="d-flex align-items-center justify-content-between vacancyRateContainer">
              <p className="sub_text mb-0">Cap Rate</p>
              <p className="sub_text fw-bold mb-0 ">9.8%</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CapRateComponent;
